export enum EditAddressDialogResultType {
  Create,
  Edit,
  Delete,
}
